import * as types from './mutation-types'


const mutations = {
  [types.SET_USER](state, value) {
    state.user = value
  },
  [types.CLEAR_USER](state) {
    state.user = null
  },
  [types.SET_COLLEGE](state, value) {
    state.college = value
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js